<template>
    <main-content v-if="$can('update-info','deposit-gateway')" with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <form id="add_company_form">
                    <kt-row>
                        <kt-col lg="4" md="6" sm="12">
                            <kt-form-group>
                                <kt-form-label for="title">
                                    {{ $t('deposit.company_title') }}
                                </kt-form-label>
                                <kt-form-control
                                    id="title"
                                    name="title"
                                    v-model="form_data.title"
                                    class="form-control"
                                ></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="3" md="4" sm="12">
                            <kt-form-group>
                                <kt-form-label for="status">
                                    {{ $t('label.status') }}
                                </kt-form-label>
                                <kt-form-select
                                    id="status"
                                    name="status"
                                    v-model="form_data.status"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        value="0">
                                        {{ $t('label.inactive') }}
                                    </option>
                                    <option
                                        value="1">
                                        {{ $t('label.active') }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="3" md="4" sm="12">
                            <kt-form-group>
                                <kt-form-label for="wage_type">
                                    {{ $t('label.wage_type') }}
                                </kt-form-label>
                                <kt-form-select
                                    id="wage_type"
                                    name="wage_type"
                                    v-model="form_data.wage_type"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        value="1">
                                        {{ $t('deposit.normal_wage') }}
                                    </option>
                                    <option
                                        value="2">
                                        {{ $t('deposit.internal_wage') }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <div class="row" style="display: block;margin-top: 50px; padding-right: 20px">
                        <kt-form-section data-repeater-list="sheba_numbers">
                            <p style="font-size: medium;margin: 30px 0">
                                {{ $t('deposit.company_accounts') }}
                            </p>
                            <div id="sheba_page"></div>
                            <kt-form-group hor data-repeater-item v-for="(account,index) in form_data.accounts"
                                           :key="index">
                                <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                                    <kt-row>
                                        <kt-col lg="9" md="9" sm="12" xs="12">
                                            <kt-form-group>
                                                <kt-form-label>
                                                    {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                                </kt-form-label>
                                                <kt-input-group class="" id="sheba_number">
                                                    <kt-form-control
                                                        dir="ltr"
                                                        :name="'accounts.'+index+'.sheba_number'"
                                                        aria-describedby="national_code-error"
                                                        :data-id="'accounts.'+index+'.sheba_number'"
                                                        v-model="form_data.accounts[index].sheba_number"></kt-form-control>
                                                    <kt-input-group-append class="ir-append">
                                                        <kt-input-group-text>IR</kt-input-group-text>
                                                    </kt-input-group-append>
                                                    <kt-input-group-append
                                                        v-if="form_data.accounts[index].sheba_number">
                                                        <img height="38px"
                                                             :id="index"
                                                             :src="BankLogo(BankNameBySheba('IR'+ form_data.accounts[index].sheba_number))">
                                                    </kt-input-group-append>
                                                </kt-input-group>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col lg="9" md="9" sm="12" xs="12">
                                            <kt-form-group>
                                                <kt-form-label>
                                                    {{ $t('label.account_number') }}
                                                </kt-form-label>
                                                <kt-input-group class="" id="account_number">
                                                    <kt-form-control dir="ltr"
                                                                     :name="'accounts.'+index+'.account_number'"
                                                                     aria-describedby="national_code-error"
                                                                     :data-id="'accounts.'+index+'.account_number'"
                                                                     v-model="form_data.accounts[index].account_number"></kt-form-control>
                                                </kt-input-group>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                </div>
                                <div
                                    class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                                    <kt-form-group>
                                        <a @click="deleteAccount(index)"
                                           class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right my-2"
                                           :id="`delete_acc_btn_${index}`">
                                            <i class="la la-trash-o"></i>
                                            {{ $t('btn.delete') }}
                                        </a>
                                    </kt-form-group>
                                </div>
                            </kt-form-group>
                        </kt-form-section>

                        <kt-form-group hor>
                            <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                                <form id="add_new_account">
                                    <kt-row>
                                        <kt-col lg="9" md="9" sm="12" xs="12">
                                            <kt-form-group>
                                                <kt-form-label>
                                                    {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                                </kt-form-label>
                                                <kt-input-group class="" id="new_sheba_number">
                                                    <kt-form-control dir="ltr"
                                                                     name="new_sheba_number"
                                                                     aria-describedby="new_sheba_number-error"
                                                                     data-id="new_sheba_number"
                                                                     v-model="new_sheba_number"></kt-form-control>
                                                    <kt-input-group-append class="ir-append">
                                                        <kt-input-group-text>IR</kt-input-group-text>
                                                    </kt-input-group-append>
                                                    <kt-input-group-append v-if="new_sheba_number">
                                                        <img height="38px"
                                                             :src="BankLogo(BankNameBySheba('IR'+new_sheba_number))">
                                                    </kt-input-group-append>
                                                </kt-input-group>
                                            </kt-form-group>
                                            <kt-form-group>
                                                <kt-form-label>
                                                    {{ $t('label.account_number') }}
                                                </kt-form-label>
                                                <kt-input-group class="" id="new_account_number">
                                                    <kt-form-control dir="ltr"
                                                                     name="new_account_number"
                                                                     aria-describedby="new_account_number-error"
                                                                     data-id="new_account_number"
                                                                     v-model="new_account_number"></kt-form-control>
                                                </kt-input-group>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                </form>
                            </div>
                            <div
                                class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                                <kt-form-group id="add_button">
                                    <a @click="addAccount()"
                                       id="add_account_btn"
                                       class="btn btn-bold btn-sm btn-label-brand"
                                    >
                                        <i class="la la-plus"></i>
                                        {{ $t('btn.add') }}
                                    </a>
                                </kt-form-group>
                            </div>
                        </kt-form-group>
                    </div>
                    <kt-form-action class="mt-4 float-right">
                        <button
                            id="submit_btn"
                            class="btn btn-md btn-success btn-wide"
                            @click.prevent="addCompany"
                        >
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>

import mainContent from '@/components/main-content'
import $ from "jquery";
import {depositPfService, depositStarshopService} from "@/common/api.service"
import {KTApp} from '@/plugins/core/app';
import {KTUtil} from '@/plugins/core/util'
import {i18n} from "@/plugins/i18n";
import Divider from "@/components/elements/dropdown/divider.vue";
import Inputmask from 'inputmask'
import Img from "@/components/elements/img.vue";


export default {
    components: {
        Img,
        Divider,
        mainContent
    },
    data() {
        return {
            form_data: {
                accounts: []
            },
            company: {},
            new_account_number: '',
            new_sheba_number: '',
            depositPfService,
            depositStarshopService
        }
    },
    methods: {
        addCompany() {
            let form = $('#add_company_form');
            let btn = $('#submit_btn');

            form.validate({
                rules: {
                    title: {
                        required: true,
                    },
                    status: {
                        required: true,
                    } ,
                    wage_type: {
                        required: true,
                    }
                },
            });
            if (!form.valid()) {
                return
            }
            if (this.form_data.accounts.length < 1)
                return this.toastr.error(i18n.t('deposit.message.add_account_required'))
            KTApp.progress(btn)
            let params = {
                accounts: [],
                status: this.form_data.status,
                title: this.form_data.title,
                wage_type: this.form_data.wage_type
            }
            for (let i = 0; i < this.form_data.accounts.length; i++) {
                params.accounts.push({
                    account_number: this.form_data.accounts[i].account_number,
                    sheba_number: 'IR'+this.form_data.accounts[i].sheba_number,
                })
            }
            this.apiService.addCompany(params).then(response => {
                this.$router.push('/open-banking/deposit/' + this.gatewaySource + '/accounts#verified_companies')
            }).catch(({response}) => {
                if (response.data)
                    form.validate().showErrors(response.data.data);

                return this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        addAccount() {
            let form = $('#add_new_account');
            let btn = $('#add_account_btn');
            form.validate({
                rules: {
                    new_account_number: {
                        required: true,
                    },
                    new_sheba_number: {
                        required: true,
                    }
                },
            });
            if (!form.valid()) {
                return
            }
            let new_sheba = this.new_sheba_number
            new_sheba = new_sheba.split('-').join('')
            new_sheba = new_sheba.split(' ').join('')
            new_sheba = new_sheba.split('_').join('')

            if (!this.isShebaValid('IR' + new_sheba))
                return this.toastr.error(i18n.t('deposit.message.sheba_is_not_valid'))

            for (var i = 0; i < this.form_data.accounts.length; i++) {
                if (this.form_data.accounts[i].account_number === this.new_account_number)
                    return this.toastr.error(i18n.t('deposit.message.account_number_is_duplicate'))
                if (this.form_data.accounts[i].sheba_number === new_sheba)
                    return this.toastr.error(i18n.t('deposit.message.sheba_number_is_duplicate'))
            }

            this.form_data.accounts.push({
                sheba_number: new_sheba,
                account_number: this.new_account_number,
            })
            this.new_account_number = null
            this.new_sheba_number = null
            this.afterDispatch()
        },
        deleteAccount(index) {
            this.form_data.accounts.splice(index, 1)
        },
        updateAccount(index) {

        },
        afterDispatch() {
            setTimeout(() => {
                Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#new_sheba_number input'))
            }, 1000);
            setTimeout(() => {
                Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#sheba_number input'))
            }, 1000);
        }
    },
    updated() {
        this.afterDispatch()
    },
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        }
    }
}
</script>

<style>
#add_button {
    margin-top: 30px;
    margin-right: -122px
}

.kt-input-icon > .kt-input-icon__icon.kt-input-icon__icon--left {
    top: -26px;
}

.ir-append {
    height: 38.2px !important;
}

@media screen and (max-width: 1024px) {
    .ir-append {
        height: 35.9px !important;
    }

}

@media screen and (max-width: 769px) {
    #add_button {
        margin-top: 0;
        margin-right: 0
    }
}

@media screen and (max-width: 681px) {
    .kt-input-icon > .kt-input-icon__icon.kt-input-icon__icon--left {
        top: -40px;
    }
}
</style>